<section>
    <p-toolbar>
        <div class="p-toolbar-group-left">
            <p-triStateCheckbox
                [(ngModel)]="triModeValue"
                label="{{ this.activeLabel }}"
                (onChange)="applyFiltering()"
            ></p-triStateCheckbox>
        </div>

        <div class="p-toolbar-group-right">
            <p-splitButton
                label="Sort Options"
                icon="fa-light fa-sort"
                [model]="items"
            ></p-splitButton>

            <span class="p-input-icon-left tw-ml-3">
                <i class="pi pi-search"></i>
                <input
                    type="text"
                    pInputText
                    placeholder="Search"
                    [(ngModel)]="searchValue"
                    (ngModelChange)="searchFilterOrchestrations(searchValue)"
                />
            </span>
        </div>
    </p-toolbar>
</section>

<p-scrollPanel [style]="{ width: '100%', height: '75vh' }" class="tw-flex-100">
    <div class="custom-card tw-flex-100">
        <p-dataView
            #dv
            [value]="this.orchestrationTargetingRules"
            [paginator]="true"
            [rows]="12"
            layout="grid"
        >
            <ng-template let-products pTemplate="listItem">
                <div class="tw-flex tw-flex-col tw-w-full">
                    @for(product of products; track product){
                    <div class="col-12">
                        <div class="product-list-item">
                            <div class="product-list-detail">
                                <div class="product-description">
                                    Channel: <b>{{ product.channelType }}</b>
                                </div>
                                <div class="product-name">
                                    {{ product.orchestrationName }}
                                </div>
                            </div>

                            <div class="product-list-action">
                                <span class="p-float-label">
                                    <p-inputNumber
                                        id="inputtext"
                                        [(ngModel)]="product.value"
                                        mode="decimal"
                                        styleClass="input-styling-list"
                                        [showButtons]="true"
                                        inputId="minmax-buttons"
                                        [min]="0"
                                        [max]="99999"
                                        (onInput)="this.changedValue = true"
                                        (onBlur)="
                                            activeValueBlur($event, product.id)
                                        "
                                    >
                                    </p-inputNumber>
                                    <label for="inputtext">Count</label>
                                </span>

                                <p-toggleButton
                                    class="tw-mt-2"
                                    icon="pi pi-shopping-cart"
                                    onLabel="Active"
                                    offLabel="InActive"
                                    (onChange)="
                                        updateTenantRule($event, product.id)
                                    "
                                    [(ngModel)]="product.active"
                                    onIcon="fa-light fa-check"
                                    offIcon="fa-light fa-xmark"
                                    pTooltip="Press to change the active status"
                                    tooltipPosition="top"
                                    tooltipZIndex="999999"
                                >
                                </p-toggleButton>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </ng-template>

            <ng-template let-products pTemplate="gridItem">
                <div class="tw-flex tw-flex-wrap">
                    @for(product of products; track product){
                    <div class="col-3">
                        <div class="product-grid-item card custom-card">
                            <div class="product-grid-item-top">
                                <div>
                                    <div
                                        class="mb-5"
                                        pTooltip="{{ product.channelType }}"
                                        tooltipPosition="right"
                                    >
                                        <i
                                            [className]="this.campaignIcon"
                                            style="
                                                font-size: 1.5rem;
                                                margin-right: 0.5rem;
                                            "
                                            [ngStyle]="{ color: '#2196F3' }"
                                        >
                                        </i>
                                        Channel:
                                        <b>{{ product.channelType }}</b>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="product-grid-item-content"
                                pTooltip="{{ product.orchestrationName }}"
                                tooltipPosition="right"
                            >
                                <div class="product-name">
                                    {{ product.orchestrationName }}
                                </div>
                            </div>
                            <div class="product-grid-item-bottom">
                                <div class="p-toolbar-group-left">
                                    <p-toggleButton
                                        icon="pi pi-shopping-cart"
                                        onLabel="Active"
                                        offLabel="InActive"
                                        (onChange)="
                                            updateTenantRule($event, product.id)
                                        "
                                        [(ngModel)]="product.active"
                                        onIcon="fa-light fa-check"
                                        offIcon="fa-light fa-xmark"
                                        pTooltip="Press to change the campaign active status"
                                        tooltipPosition="top"
                                    >
                                    </p-toggleButton>
                                </div>

                                <div class="p-toolbar-group-right">
                                    <span class="p-float-label">
                                        <p-inputNumber
                                            id="inputtext"
                                            [(ngModel)]="product.value"
                                            mode="decimal"
                                            styleClass="input-styling"
                                            [showButtons]="true"
                                            inputId="minmax-buttons"
                                            [min]="0"
                                            [max]="99999"
                                            (onInput)="this.changedValue = true"
                                            (onBlur)="
                                                activeValueBlur(
                                                    $event,
                                                    product.id
                                                )
                                            "
                                            pTooltip="Change the campaign count value"
                                            tooltipPosition="top"
                                        >
                                            >
                                        </p-inputNumber>
                                        <label for="inputtext">Count</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </ng-template>
        </p-dataView>
    </div>
</p-scrollPanel>
